import { faAnglesUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack } from "@mui/material";
import { FEED_CONTAINER_ID, FEED_FILTER_AREA_ID, FEED_RIGHT_PANEL_ID, FEED_RIGHT_PANEL_WIDTH, FEED_STACK_AREA } from "app/appConstants";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcText } from "components";
import { FEED_CONTAINER_SCROLL_TOP_ID, INSIDE_LAYOUT_CONTENT_CONTAINER_ID } from "layouts/common/inside/MprcLayoutInside";
import { JSX, useRef } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

export type RightPanelBreakpoints = "md" | "lg";

interface FeedManagerProps {
    feed: JSX.Element;
    header?: JSX.Element;
    filter?: JSX.Element;
    moreInfo?: JSX.Element;
    marginRightPanel?: number;
    rightPanelBreakpoint?: RightPanelBreakpoints;
}

export const FeedContainer = (props: FeedManagerProps) => {
    const { filter, feed, header, moreInfo, marginRightPanel, rightPanelBreakpoint = "lg" } = props;

    let feedRef = useRef<HTMLDivElement>(undefined!);
    let feedFilterRef = useRef<HTMLDivElement>(undefined!);
    const { t } = useTranslation("knowledge");

    return (
        <>
            <Box
                id={FEED_CONTAINER_SCROLL_TOP_ID}
                className={AppGlobalClassKeys.invisible}
            >
                <a onClick={() => document.getElementById(INSIDE_LAYOUT_CONTENT_CONTAINER_ID)?.scrollTo(0, 0)}>
                    <MprcText color="primary">
                        <FontAwesomeIcon icon={faAnglesUp} title={t("Feed.GotoTop")}></FontAwesomeIcon>
                    </MprcText>
                </a>
            </Box>
            <Stack id={FEED_STACK_AREA} flexDirection="column" columnGap={3}>
                {
                    filter &&
                    <Box id={FEED_FILTER_AREA_ID} ref={feedFilterRef} sx={{ minWidth: 0, mb: 2 }}>
                        {filter}
                    </Box>
                }
                <Box id={FEED_CONTAINER_ID} ref={feedRef} sx={theme => ({ display: "flex", gap: 3 })}>
                    <Box id="feedContainerWorkArea" sx={{ flex: 1, minWidth: 0 }}>
                        {
                            header &&
                            <Box id="feedContainerHeaderArea" sx={{ mb: 3 }}>
                                {header}
                            </Box>
                        }

                        <div id="feedContainerScrollArea">
                            {feed}
                        </div>
                    </Box>

                    {
                        moreInfo &&
                        <Box
                            id={FEED_RIGHT_PANEL_ID}
                            sx={
                                (theme) => ({
                                    width: FEED_RIGHT_PANEL_WIDTH,
                                    marginRight: marginRightPanel ? theme.spacing(marginRightPanel) : undefined,
                                    paddingX: theme.spacing(1),
                                    paddingY: 0,
                                    display: {
                                        xs: "none",
                                        md: rightPanelBreakpoint == "md" ? "block" : "none",
                                        lg: rightPanelBreakpoint == "lg" ? "block" : undefined
                                    },
                                    position: "sticky",
                                    top: 0,
                                    alignSelf: "start",
                                    "::-webkit-scrollbar": {
                                        width: 8,
                                        height: 8,
                                    },
                                    "::-webkit-scrollbar-track": {
                                        backgroundColor: "transparent",
                                    },
                                    "::-webkit-scrollbar-thumb": {
                                        backgroundColor: "transparent",
                                        borderRadius: "50px",
                                        border: "3px solid transparent"
                                    },
                                    "&:hover": {
                                        "::-webkit-scrollbar-thumb": {
                                            backgroundColor: "grey",
                                            border: "3px solid grey"
                                        },
                                        "::-webkit-scrollbar-track": {
                                            backgroundColor: "lightgray",
                                        }
                                    }
                                })
                            }
                        >
                            {moreInfo}
                        </Box>
                    }
                </Box>
            </Stack>
        </>
    );
};
